import { useMemo } from 'react';

import { NameAndCreateDateFormatter, EnabledBadgeFormatter } from '@Components/Grid/components/Table/formatters'
import { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('type'),
    defaultColumn('throttle', 'Throttle', info => info.getValue() || '--'),
    defaultColumn('rules', 'Rules', info => <EnabledBadgeFormatter info={info} />),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
